// DS: MO3.8
import React from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';
import { PapiSellerDiscount } from '@wix/da-papi-types';
import { formatDollars } from '../utils/formatting';

import s from './DiscountLabel.scss';

export interface Props {
  className?: string;
  discount?: PapiSellerDiscount;
  textVariant?: 'percent' | 'dollars' | 'sale' | 'subscription';
  size?: 'small' | 'medium'; // small inside buttons, and medium for other places
  opaque?: boolean;
  reversedTheme?: boolean; // Reversed theme variant is to be used in the reversed background buttons such as Subscribe Button.
  // reversedTheme only affects text color, not the background color.
}

const DiscountLabel: React.FC<Props> = ({
  discount,
  className,
  textVariant = 'percent',
  size = 'medium',
  opaque = false,
  reversedTheme = false,
}) => {
  const { t } = useTranslation();
  if (!discount || !discount.amount || !discount.amount.percent) {
    return null;
  }

  return (
    <span
      className={c(
        s['root'],
        s[size],
        opaque && s['opaque'],
        reversedTheme && s['reversed-theme'],
        className
      )}
    >
      <span className={s['discount']}>
        {textVariant === 'subscription' && (
          <span className={s['percent']}>
            {discount.amount.percent === 100
              ? t('common.sale.firstMonthFree')
              : `${t('common.sale.firstMonthOnly')} ${discount.amount.percent}% ${t('common.off')}`}
          </span>
        )}
        {textVariant === 'percent' && (
          <span className={s['percent']}>
            {discount.amount.percent}% {t('common.off')}
          </span>
        )}
        {textVariant === 'dollars' && (
          <span className={s['percent']}>
            {formatDollars(discount.amount.usd)} {t('common.off')}
          </span>
        )}
        {textVariant === 'sale' && <span className={s['percent']}>{t('common.onSale')}</span>}
      </span>
    </span>
  );
};

DiscountLabel.displayName = 'DiscountLabel';

export default DiscountLabel;
